<template>
  <div class="cart-equipment">
    <products-expand visible-on-load
                     :group-title="$t('checkout.cartOverview.chooseEquipmentTitle')"
                     class="equipment-expand">
      <img slot="icon" src="/assets/images/icon-open-case.svg" alt="">
      <div class="equipment-body">
        <ec-carousel :carousel-options="sliderOptions">
          <ec-carousel-slide v-for="equipment in $props.equipmentList"
                             :key="equipment.code">
            <device-item :product="equipment"
                         :segment="$props.segment"
                         is-additional-offering
                         class="equipment-item"
                         @add-to-cart="handleAddToCart($event, equipment)"/>
          </ec-carousel-slide>
        </ec-carousel>
      </div>
    </products-expand>
  </div>
</template>

<script>
import ProductsExpand from '../../common/products-expand'
import { EcCarousel, EcCarouselSlide } from '../../base/mini-carousel/'
import DeviceItem from '../../plp/device-item'
import { getCookie } from '../../../utils/cookieController'
import { addProductToCart } from '../../../api/cart'
import checkoutDataLayer from '../mixins/checkoutDataLayer'

export default {
  name: 'checkout-cart-equipment',
  components: { DeviceItem, EcCarousel, EcCarouselSlide, ProductsExpand },
  mixins: [checkoutDataLayer],
  data () {
    return {
      sliderOptions: Object.freeze({
        spaceBetween: 4,
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 2
          },
          1366: {
            slidesPerView: 3
          }
        }
      })
    }
  },
  props: {
    equipmentList: {
      type: Array,
      default: () => []
    },
    segment: {
      type: String,
      default: 'PRIVATNI'
    }
  },
  methods: {
    handleAddToCart (color, product) {
      const guid = getCookie('guid')
      const dataToSend = {
        cartId: guid || 'new',
        pricePlanId: product.productOfferingPrices[0].id,
        variantProductCode: color.code || product.tmaPoVariantOptions[0].code,
        fromCheckout: true
      }
      this.$loader.show()
      addProductToCart(dataToSend)
        .then(() => {
          this.$emit('refresh-cart', true)
          this.additionalDevicesDataLayer(product, color)
        })
        .catch(e => {
          this.toast('error', {
            message: this.$t('errors.defaultError')
          })
        })
        .finally(() => {
          this.$loader.hide()
        })
    }
  }
}
</script>

<style scoped lang="scss">
.cart-equipment {
  margin-bottom: 4rem;
}

.equipment-expand /deep/ .product-expand-header {
  width: 100%;
  margin: auto;

  @media (map_get($breakpoints, sm)) {
    max-width: calc(100% - 6.4rem);
  }

  @media (map_get($breakpoints, md)) {
    max-width: 100%;
  }
}

.equipment-body {
  margin-top: 4px;
  max-width: 100%;
}

.equipment-item {
  margin: 0;
  width: 100%;
  border-radius: 5px;
  padding: 1.6rem 2.4rem;
}
</style>
